// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.8 14.001C21.3858 16.0237 20.3563 17.8688 18.8525 19.2834C17.3487 20.6981 15.4442 21.6131 13.4 21.903V19.878C14.9098 19.6087 16.3106 18.9117 17.4358 17.8697C18.5611 16.8278 19.3636 15.4847 19.748 14L21.8 14.001ZM4.25201 14.001C4.63223 15.4685 5.42108 16.798 6.5269 17.835C7.63273 18.8719 9.01012 19.5738 10.499 19.859V21.889C8.47493 21.5806 6.59409 20.6589 5.11013 19.2483C3.62618 17.8376 2.61048 16.0059 2.20001 14H4.25201V14.001ZM18 11V13H17C15.9738 13 14.9868 13.3944 14.2432 14.1017C13.4996 14.809 13.0563 15.775 13.005 16.8L13 17V18H11V17C11 15.9738 10.6056 14.9868 9.89829 14.2432C9.191 13.4996 8.22497 13.0563 7.20001 13.005L7.00001 13H6.00001V11H18ZM12 2C17.185 2 21.449 5.947 21.95 11H19.938C19.694 9.0669 18.7529 7.28927 17.2914 6.00068C15.8299 4.71208 13.9485 4.00108 12 4.00108C10.0516 4.00108 8.17008 4.71208 6.70858 6.00068C5.24709 7.28927 4.30604 9.0669 4.06201 11H2.04901C2.55101 5.947 6.81501 2 12 2Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
